'use client';

import { Box, BoxProps, forwardRef } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface Props {
  size?: 'small' | 'regular' | 'large';
  children: ReactNode | Array<ReactNode>;
  fontWeight?: 'light' | 'regular' | 'medium' | 'bold' | 'bolder';
}

const Text = forwardRef<BoxProps & Props, 'p'>(({ size = 'regular', color = 'text/body', children, ...rest }, ref) => {
  return (
    <Box
      as="p"
      ref={ref}
      textStyle={`body.${size}`}
      sx={{
        // TODO: Margin 0 can be removed as it uses Box default margin
        m: 0,
        color
      }}
      {...rest}
    >
      {children}
    </Box>
  );
});

export default Text;
